var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { class: ['hamburger-container', { 'text-center': _vm.isActive }], on: { "click": _vm.toggleClick } }, [_c('svg-icon', { staticClass: "svgColor", attrs: { "size": 20, "icon-class": !_vm.isActive ? 'pt_stow' : 'pt_open' } }), _vm._v(" "), _c('span', { directives: [{ name: "show", rawName: "v-show", value: !_vm.isActive, expression: "!isActive" }], staticClass: "svgInfo" }, [_vm._v(_vm._s(_vm.$t('playTurbo.whole.fold')))])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };